import type { PublicApiKey } from '@/apilib';
import type { createAccountApi } from './accountApi';

export const AccountApiKey: PublicApiKey<typeof createAccountApi> = {
  name: 'AccountApi',
  public: true,
};
